import React from "react";

const ProsCons = ({ type = "pro", comment = "", ...rest }) => {

    if (type !== "pro") {
        return <div {...rest} className="pro-con-widget">
                    <div className="pro-con-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#CC1D10" width="24px" height="24px">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </div>
                    <div className="pro-con-txt">
                        {comment}
                    </div>
                </div>
    }

    return <div {...rest} className="pro-con-widget">
                <div className="pro-con-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0BD926" width="24px" height="24px">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                </div>
                <div className="pro-con-txt">
                    {comment}
                </div>
            </div>

};

export default ProsCons;